// Single boundary for Vite `import.meta.env` access.
// Tests can mock this module once instead of dealing with `import.meta` under ts-jest.
export const env = {
  VITE_BASE_URL: import.meta.env.VITE_BASE_URL,
  DEV: import.meta.env.DEV,
  MODE: import.meta.env.MODE,
};
